import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable( {
  providedIn: 'root'
} )
export class GroupCTemplateService {

  public currentUser = JSON.parse( sessionStorage.getItem( 'currentUser' ) );

  constructor( private http: HttpClient ) {
  }

  /**
   * Método encargado de cargar un examen
   * @param request
   * @returns
   */
  loadExam( request: any, baseUrl: string ): Observable<any> {
    request = this.loadSessionFields( request );
    return this.http.post<any>( this.buildUrlApi( baseUrl ), request );
  }

  /**
   * Método encargado de construir la URL del end-point para cargar examenes
   * @param method
   * @returns
   */
  buildUrlApi( method: string ): string {
    return `${ environment.apiUrl }` + method;
  }

  /**
   * Método encargado de agregar a los request los campos comunes correspondientes al usuario logueado
   * @param request
   * @returns
   */
  private loadSessionFields( request: any ): any {
    request.modelId = this.currentUser.modelId;
    request.userId = this.currentUser.userId;
    request.prestadorCod = this.currentUser.prestadorCod;
    return request;
  }
}


